<template>
  <div
    v-if="onboardingStatus === 'PROVISIONING'"
    class="application-review-container"
  >
    <div class="review-message">
      Your bank account details are in review 👀.
    </div>
    <s-notification variant="primary" width="full">
      This takes anything from a few minutes up to a maximum of 2 business days.
    </s-notification>
  </div>
  <div v-else class="add-bank-account-container">
    <div class="add-bank-account-message">
      Add your bank account so you can receive funds.
    </div>
    <div class="add-bank-account-button-wrapper">
      <c-button @click="navigateTo()" variant="primary">
        <span class="add-bank-account-button-text">Add bank account</span>
      </c-button>
    </div>
  </div>
</template>

<script>
import { navigateWithParam } from "@/router";
import { RouteConstants } from "@/router/routeConstants";

export default {
  name: "AddBankAccount",
  props: {
    onboardingStatus: {
      type: String,
      default: null,
    }
  },
  methods: {
    navigateTo() {
      navigateWithParam(RouteConstants.INCREMENTAL_ONBOARDING_ADD_BANK_ACCOUNT);
    }
  }
};
</script>

<style lang="scss">

.add-bank-account-container {
  display: flex;
  flex-direction: column;
  padding: unset;

  .add-bank-account-message {
    text-align: left;
    font-size: 14px;
  }

  .add-bank-account-button-wrapper {
    margin-top: 12px;
    font-size: 14px;

    .c-button {
      display: flex;

      .c-button__label {
        padding: unset !important;
      }

      .add-bank-account-button-text {
        display: flex;
        padding-right: 4px;
        font-weight: $fw_medium;
        font-size: 14px;
      }

      .button-label {
        display: flex;
        align-items: center;
        font-weight: $fw_medium;
      }
    }
  }
}

.application-review-container {
  display: flex;
  flex-direction: column;
  font-weight: 400;

  .review-message {
    display: flex;
    margin-bottom: 8px;
  }
}

</style>